import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ConfigProvider, message, Spin } from "antd";
import axios from "axios";

import Program from "./pages/Program";
import Faculty from "./pages/Faculty";
import Committees from "./pages/Committees";
import Sponsors from "./pages/Sponsors";
import SponsorsType from "./pages/SponsorsType";
import Login from "./pages/Login";
import WelcomeLetter from "./pages/WelcomeLetter";
import Notifications from "./pages/Notifications.js";
import Settings from "./pages/Settings.js";
import PageNotFound from "./pages/PageNotFound.js";
import Main from "./layout/Main.js";

import api from "./utils/api.js";

//import "./assets/styles/global.css";
import "./assets/styles/pages.css";
import "./index.css";
import Users from "./pages/Users.js";

import Room from "./pages/Room.js";
import Dashboard from "./pages/Dashboard.js";
import Faq from "./pages/Faq.js";
import Credits from "./pages/Credits.js";
import Game from "./pages/Game.js";

api.axiosCreate();

function App() {
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();

  function handleLogout() {
    localStorage.removeItem("token");
    navigate("/login");
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#24588D",
          fontFamily: "Poppins",
        },
      }}
    >
      <div className={`App ${window.location.pathname.includes("/admin") ? "admin" : ""}`}>
        {contextHolder}
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route element={<Main handleLogout={handleLogout} />}>
            <Route index exact path="/" element={<Navigate to={`/program`} replace />} />
            <Route exact path="/login" element={<Navigate to={`/program`} replace />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/program" element={<Program />} />
            <Route exact path="/room" element={<Room />} />
            <Route exact path="game" element={<Game />} />
            <Route exact path="/faculty" element={<Faculty />} />
            <Route exact path="/committees" element={<Committees />} />
            <Route exact path="/faq" element={<Faq />} />
            <Route exact path="/sponsors" element={<Sponsors />} />
            <Route exact path="/sponsors-type" element={<SponsorsType />} />
            <Route exact path="/welcome-letter" element={<WelcomeLetter />} />
            <Route exact path="/credits" element={<Credits />} />
            <Route exact path="/notifications" element={<Notifications />} />
            <Route exact path="/settings" element={<Settings />} />
            <Route exact path="/users" element={<Users />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;
